import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"

export default function Category() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0

    return (
        <div class="ns-serp ns-mx-auto" data-collection-new>
            <div class="container">
                <div class="collection-results">
                    {(foundProducts || (loading && foundProducts)) && <Toolbar />}
                    <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-my-0 ns-mx-auto">
                        {foundProducts && (
                            <>
                                <Sidebar />
                                {/* <Toolbar mobile /> */}
                            </>
                        )}
                        <div class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 collection-results results">
                            {foundProducts ? (
                                <>
                                    <SelectedFilters />
                                    <Products />
                                    <BottomToolbar />
                                </>
                            ) : loading ? (
                                <Loader />
                            ) : (
                                <NoResults />
                            )}

                            {/* To enable InfiniteScroll - comment above block and uncomment below.
                                Don't forget to import InfiniteScroll component. */}
                            {/* {foundProducts ? (
                                <>
                                    <SelectedFilters />
                                    <Toolbar />
                                    <InfiniteScroll>
                                        <Products />
                                    </InfiniteScroll>
                                </>
                            ) : loading ? (
                                <Loader />
                            ) : (
                                <NoResults />
                            )} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
